// MowKind crest — final.
//
// Outlined heater shield. The inner etching is intentionally broken on
// the verticals — split into a TOP CROWN (chief band, only ~7 units of
// vertical reach) and a BOTTOM BOWL (the lower curve). A 22-unit gap on
// each vertical opens the entire midsection so the MK monogram floats
// in clear space — maximum dimensionality.
//
// Uses currentColor so the mark inherits whatever text color it sits
// against. Component name "ShieldMark" retained for backward
// compatibility with existing imports.

interface Props {
  size?: number;
  className?: string;
  title?: string;
}

export function ShieldMark({ size = 32, className = '', title }: Props) {
  return (
    <svg
      width={size}
      height={(size * 72) / 64}
      viewBox="0 0 64 72"
      xmlns="http://www.w3.org/2000/svg"
      className={className}
      role={title ? 'img' : 'presentation'}
      aria-label={title}
      aria-hidden={title ? undefined : true}
      fill="none"
      stroke="currentColor"
    >
      {title ? <title>{title}</title> : null}

      {/* Outer shield — heater silhouette */}
      <path
        strokeWidth="2.8"
        strokeLinejoin="round"
        d="M 12 6 L 52 6 L 56 10 L 56 44 Q 56 58 32 68 Q 8 58 8 44 L 8 10 Z"
      />

      {/* Inner etching · TOP CROWN — chief band with short vertical stubs */}
      <path
        strokeWidth="0.8"
        strokeLinecap="round"
        strokeLinejoin="round"
        d="M 11 20 L 11 13 L 14 10 L 50 10 L 53 13 L 53 20"
      />

      {/* Inner etching · BOTTOM BOWL — the lower curve, tiny vertical stubs */}
      <path
        strokeWidth="0.8"
        strokeLinecap="round"
        strokeLinejoin="round"
        d="M 11 42 L 11 43 Q 11 55 32 63 Q 53 55 53 43 L 53 42"
      />

      {/* MK monogram — serif caps, floats in the open midsection.
          Uses Fraunces (the same display serif your wordmark uses) so the
          mark and the "MowKind" wordmark rhyme typographically. */}
      <text
        x="32"
        y="38"
        textAnchor="middle"
        fontFamily="'Fraunces', 'Cormorant Garamond', 'Playfair Display', Georgia, 'Times New Roman', serif"
        fontSize="23"
        fontWeight="500"
        fill="currentColor"
        stroke="none"
        letterSpacing="-1.5"
        style={{ fontVariationSettings: '"opsz" 144, "SOFT" 30' }}
      >
        MK
      </text>

      {/* Divider line under the monogram */}
      <line
        x1="20"
        y1="46"
        x2="44"
        y2="46"
        strokeWidth="1"
        strokeLinecap="round"
      />

      {/* Three grass-blade marks at the foot */}
      <g strokeWidth="1.3" strokeLinecap="round" strokeLinejoin="round">
        <polyline points="22,57 24,52 26,57" />
        <polyline points="30,57 32,52 34,57" />
        <polyline points="38,57 40,52 42,57" />
      </g>
    </svg>
  );
}
